import { useEffect, useState } from 'react';

interface ImageProps {
  name: string;
  alt: string;
  classes?: string;
  width: string;
  height: string;
}

function Image({ name, alt, classes, width, height }: ImageProps): JSX.Element {
  const [image, setImage] = useState('');

  useEffect((): void => {
    const importImage = async (): Promise<void> => {
      let importedImage = await import(`../../images/${name}`);
      setImage(importedImage.default);
    };

    importImage();
  }, [name]);

  return !image ? (
    <div
      className={`placeholder ${classes}`}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        minWidth: `${width}px`,
      }}
    />
  ) : (
    <img
      className={classes}
      src={image}
      alt={alt}
      width={width}
      height={height}
    />
  );
}

export default Image;
